(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-cinta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Hero Cinta — reveal ligado al scroll (lema → título → texto → botón).
       Silencioso: fundido + 14px de desplazamiento, sin rebotes. No secuestra el
       scroll. Sin JS o con prefers-reduced-motion todo queda visible. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var SEL = '.hero-cinta__eyebrow, .hero-cinta__heading, .hero-cinta__text, .hero-cinta__button';
    var items = [];
    var ticking = false;

    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function collect() {
      items = [];
      document.querySelectorAll('.hero-cinta__content').forEach(function (box) {
        box.querySelectorAll(SEL).forEach(function (el, i) {
          items.push({ el: el, box: box, i: i });
        });
      });
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight || 800;
      items.forEach(function (it) {
        var top = it.box.getBoundingClientRect().top;
        /* Cada elemento aparece al recorrer ~10% de la pantalla, con 6% de retraso
           entre uno y otro. La secuencia completa termina cuando el bloque llega a
           ~70% de la altura, es decir, antes de que la sección quede a pantalla completa. */
        var start = vh * (0.99 - it.i * 0.05);
        var t = clamp((start - top) / (vh * 0.12));
        it.el.style.setProperty('--tw-r', t.toFixed(3));
      });
    }

    function request() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    function init() {
      collect();
      if (!items.length) return;
      update();
    }

    init();
    /* En escritorio (≥990px) el scroll vive en .page-wrapper, no en window: captura en document */
    document.addEventListener('scroll', request, { passive: true, capture: true });
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
